import DOMPurify from 'dompurify';
import ul from '../../../assets/icons/ul.svg';

const ListComponent = ({ ordered, children }) => {
  const Tag = ordered ? 'ol' : 'ul';


  return <Tag className="col-12 mb-3 anchor ml-3">{children}</Tag>;
};

export const ListParagraph = ({ paragraph, ordered }) => (
  <ListComponent ordered={ordered}>
    {paragraph.blocks.map((block, j) => (

      <li key={j} className={`${block.class} mb-[20px] flex items-center`}>
        {ordered? <span className="mr-2">{j + 1}.</span> : (
          <img src={ul} alt="ul" className="img w-[28px] h-[14px] mr-2" />
        )}
        {block.src.includes('<') ? (
          <span 
            key={j} 
            className={block.class}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.src) }}
          />    
        ) : (
          <span key={j} className={block.class}>
            {block.src} 
          </span>
        )}
      </li>
    ))}
  </ListComponent>
); 